// removed by extract-text-webpack-plugin
module.exports = {"loading":"GroupMembersTabListView__loading___1F-9U","list":"GroupMembersTabListView__list___3CK6j"};


//////////////////
// WEBPACK FOOTER
// ./src/groups/components/styles/GroupMembersTabListView.css
// module id = 2568
// module chunks = 0 1